export const LOCAL_STORAGE_KEYS = {
  IMPORT_WIZARD_PROCESSED: 'IMPORT_WIZARD_PROCESSED',
  IMPORT_WIZARD_RAW: 'IMPORT_WIZARD_RAW',
  IMPORT_WIZARD_OVERWRITTEN: 'IMPORT_WIZARD_OVERWRITTEN',
  IMPORT_WIZARD_COUNTABLE_LOCATIONS: 'IMPORT_WIZARD_COUNTABLE_LOCATIONS',
  IMPORT_WIZARD_INVENTORY_DATE: 'IMPORT_WIZARD_INVENTORY_DATE',
  IMPORT_WIZARD_SELECTED_BACKBAR_COLUMNS: 'IMPORT_WIZARD_SELECTED_BACKBAR_COLUMNS',
  IMPORT_WIZARD_SELECTED_BACKBAR_COLUMNS_OBJECT: 'IMPORT_WIZARD_SELECTED_BACKBAR_COLUMNS_OBJECT',
  IMPORT_WIZARD_EDITED_CELLS: 'IMPORT_WIZARD_EDITED_CELLS',

  // MODAL LOCAL STORAGE KEYS
  MODAL_GETTING_STARTED_UPGRADE: 'MODAL_GETTING_STARTED_UPGRADE',
  MODAL_FREE_TRIAL_ENDED: 'MODAL_FREE_TRIAL_ENDED',

  DASHBOARD_BANNER_UNVERIFIED_ACCOUNT: 'DASHBOARD_BANNER_UNVERIFIED_ACCOUNT',
  DASHBOARD_BANNER_UPGRADE_NOTICE: 'DASHBOARD_BANNER_UPGRADE_NOTICE',
  DASHBOARD_BANNER_TRIAL_PAYMENT_MISSING: 'DASHBOARD_BANNER_TRIAL_PAYMENT_MISSING'
}

export type LocalStorageKey = (typeof LOCAL_STORAGE_KEYS)[keyof typeof LOCAL_STORAGE_KEYS]

export class LocalStorageService {
  static setItem<T>(key: string, value: T): void {
    try {
      const serializedValue = JSON.stringify(value)
      localStorage.setItem(key, serializedValue)
    } catch (error) {
      console.error(`Error saving to localStorage with key: ${key}`, error)
    }
  }

  static getItem<T>(key: string): T | null {
    try {
      const serializedValue = localStorage.getItem(key)
      return serializedValue ? (JSON.parse(serializedValue) as T) : null
    } catch (error) {
      console.error(`Error reading from localStorage with key: ${key}`, error)
      return null
    }
  }

  static removeItem(key: string): void {
    localStorage.removeItem(key)
  }

  static clearAll(): void {
    localStorage.clear()
  }
}
